import React from 'react';
import WelcomeVideoContainer from './WelcomeVideoContainer';
import WelcomeVideoHeader from './WelcomeVideoHeader';
import styles from './welcomeVideo.module.css';
import { LANDPAGE_WELCOME_VIDEO } from '../../landpage.constants';

const WelcomeVideoSection: React.FC = () => {
  const copy = LANDPAGE_WELCOME_VIDEO;

  return (
    <section className={styles.section}>
      {/* <WelcomeVideoHeader title={copy.title} /> */}
      <WelcomeVideoContainer embedUrl={copy.embedUrl} title={copy.title} />
    </section>
  );
};

export default WelcomeVideoSection;
